import React from 'react';
import { MyPortfolioCapsuleContentProps } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';

import { histPriceVolStreamedDataSelectors } from '../../store/data/streamSlice.ts';
import { useHistoricalPercentageChangeCapsuleConfigSlice } from 'widgets/historicalPercentageChange/capsule/store.ts';
import { HistoricalPercentageChangeCapsuleContent } from 'widgets/historicalPercentageChange/capsule/components/HistoricalPercentageChangeCapsuleContent.tsx';
import { initialHistPriceVolDataState } from 'widgets/historicalPercentageChange/store/data/HistoricalPercentageChangeDataState.ts';

export function HistoricalPercentageChangeMyPortfolioCapsuleContent(
    props: MyPortfolioCapsuleContentProps
) {
    const { symbol } = props;
    const { config } = useHistoricalPercentageChangeCapsuleConfigSlice();

    const { useSymbolStreamedData } = histPriceVolStreamedDataSelectors;

    const streamData =
        useSymbolStreamedData(symbol, config) ?? initialHistPriceVolDataState;

    return <HistoricalPercentageChangeCapsuleContent streamData={streamData} />;
}
